if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.languageChosenByUser = false;
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        ['Sprog', 'Language'].forEach((name) => {
          document.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
            input.addEventListener('click', () => {
              this.languageChosenByUser = true;
            
              const fieldset = input.closest('.product-form__input--language');
              if (fieldset) {
                fieldset.classList.add('language-chosen');
                fieldset.classList.remove('error');
              }
            
              this.handleErrorMessage(); // clear error instantly
            });
          });
        });
        
        
        
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const formData = new FormData(this.form);

    // === Language validation (user MUST choose a language) ===
      const languageNames = ['Sprog', 'Language'];

      // Find inputs for either option name
      const languageInputsByName = languageNames.map(name => ({
        name,
        inputs: [...document.querySelectorAll(`input[name="${name}"]`)]
      }));

      // Find which language option actually exists
      const activeLanguageOption = languageInputsByName.find(group => group.inputs.length > 0);

      if (activeLanguageOption) {
        const { name, inputs } = activeLanguageOption;
        const isChecked = this.languageChosenByUser;

        if (!isChecked) {
          const errorMessage =
            name === 'Sprog'
              ? 'Vælg venligst et sprog'
              : 'Please choose a language';

          this.handleErrorMessage(errorMessage);

          // Highlight the correct fieldset
          const languageFieldset = [...document.querySelectorAll('fieldset')].find(fs => {
            const legend = fs.querySelector('legend');
            if (!legend) return false;

            const text = legend.textContent.trim().toLowerCase();
            return text.includes(name.toLowerCase());
          });

          if (languageFieldset) languageFieldset.classList.add('error');

          return; // 🚫 BLOCK ADD TO CART
        }
      }
      // === END Language validation ===


    
        const productColors = document.querySelectorAll('.product__colors');
        const uniqueId = `pid_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
        let allSelected = true;
        const selectedColors = [];
        if (productColors) {
          productColors.forEach((colorSet) => {
            const selectedSwatch = colorSet.querySelector('.color-swatch__item.selected');
            if (!selectedSwatch) {
              allSelected = false;
            } else {
              const yarnQuantity = selectedSwatch.dataset.sizevalue || 1;
              const yarnId = selectedSwatch.dataset.variantId;
              const yarnName = selectedSwatch.dataset.colorname || '';
              const setNumber = selectedSwatch.dataset.colorSet || selectedColors.length + 1;
              selectedColors.push({ yarnId, yarnQuantity, uniqueId, yarnName, setNumber });
            }
          });
        }
        if (!allSelected) {
          this.handleErrorMessage("Please select a color");
          productColors.forEach((colorSet) => {
            const selectedSwatch = colorSet.querySelector('.color-swatch__item.selected');
            if (!selectedSwatch) {
              colorSet.classList.add('error');
            }
          });
          return;
        };
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');


        // === Custom: Add swatch variant ===
        async function addSwatches() {
          for (const color of selectedColors) {
            const productQuantity = formData.get('quantity') || 1;
            const productName = formData.get('product-name') || document.querySelector('.product__title > h1').textContent;
            const swatchVariantId = color.yarnId;
            const swatchQuantity = parseInt(color.yarnQuantity) * productQuantity || 1;
            const uniqueId = color.uniqueId;

            console.log(`Adding swatch variant ID: ${swatchVariantId}, Quantity: ${swatchQuantity}`);

            const swatchFormData = new FormData();
            swatchFormData.append('id', swatchVariantId);
            swatchFormData.append('quantity', swatchQuantity);
            swatchFormData.append('properties[_UniqueId]', uniqueId);
            swatchFormData.append('properties[_ColorSet]', color.setNumber);
            swatchFormData.append('properties[_YarnQuantity]', swatchQuantity);
            swatchFormData.append('properties[Part of]', productName);

            try {
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: swatchFormData,
              });
              await res.json();

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'swatch-add',
                productVariantId: swatchVariantId,
              });
            } catch (e) {
              console.error('Swatch add failed:', e);
            }
          }
        }
        await addSwatches(); // ✅ Wait for swatches to finish before adding main product
        // === End swatch logic ===

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          const productType = formData.get('product-type') || '';
          if (productType == 'Knit Kit' || productType == 'Knit Kits' || productType == 'Knitting Kits' ) {
            formData.append('properties[_UniqueId]', uniqueId);
            formData.append('properties[Color]', selectedColors.map(c => c.yarnName).join(', '));
          }
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
